import { formatISO } from 'date-fns';

export function formatISODate(date: Date | null) {
  return date ? formatISO(date, { representation: 'date' }) : '';
}
